exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-results .loading[data-v-0efcec5e]{display:flex;flex:1;text-align:center;justify-content:center;align-items:center;min-height:468px}.search-results .component-fade-enter-active[data-v-0efcec5e],.search-results .component-fade-leave-active[data-v-0efcec5e]{transition:opacity .3s ease}.search-results .component-fade-enter[data-v-0efcec5e],.search-results .component-fade-leave-to[data-v-0efcec5e]{opacity:0}", ""]);

// exports
